import { useQuery } from "@apollo/client";
import { useFilters } from "../../../../../providers/FilterProvider";
import { getAdminStandardsQuery } from "../modules/Query";
import _ from "lodash";

const EMPTY_OBJECT = {};

const useAdminStandardsQuery = ({
  id,
  learningCourseId,
  showCourseStandards,
}) => {
  const { filters } = useFilters();

  const { data = EMPTY_OBJECT, loading } = useQuery(getAdminStandardsQuery, {
    variables: {
      id,
      filters: {
        ...filters,
        learningCourseIds: showCourseStandards ? [learningCourseId] : [],
      },
    },
    fetchPolicy: "cache-and-network",
    context: {
      useHttpLink: true,
    },
  });

  const edges =
    data?.node?.plannerElementNodeSetWrapperV2?.publishedData?.edges || [];

  return {
    showLoader: _.isEmpty(data) && loading,
    edges,
  };
};

export default useAdminStandardsQuery;
